export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-11.ce881f0e.jpg";